import { CNUser } from './cnuser';

export class CNHealthAgent extends CNUser {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.SNUser.CNUser.CNHealthAgent';
    }

    get description(): string {
        let description = this.getProperty('Firstname') + ' ' + this.getProperty('Lastname');
        description += ' ' + (this.getProperty('INAMI') === null) ? '' : this.getProperty('INAMI');
        return description;
    }

    public clone(): any {
        return new CNHealthAgent();
    }
}
